(function () {
  var MODAL_ID = "hd-micro-conversion";
  var SESSION_STATE_KEY = "hd_micro_conversion_state";
  var PAGE_VIEW_KEY = "hd_micro_conversion_page_views";
  var HEAP_EMAIL_KEY = "heap_email";
  var DEBUG_KEY = "__hd_micro_debug";
  var IDLE_DELAY_MS = 18000;
  var modal = document.getElementById(MODAL_ID);
  if (!modal) return;

  var debugEnabled = false;
  try {
    debugEnabled = sessionStorage.getItem(DEBUG_KEY) === "true";
  } catch (e) {}
  if (window.__HD_MICRO_DEBUG__ === true && !debugEnabled) {
    debugEnabled = true;
    try {
      sessionStorage.setItem(DEBUG_KEY, "true");
    } catch (e) {}
  }

  var state = readState();
  var page_views = incrementPageViews();
  var latestCart = null;
  var latestCartSkus = [];
  var armedReason = null;
  var exitListenerAttached = false;
  var idleTimer = null;
  var idleEventsBound = false;
  var lastActiveElement = null;
  var currentVariant = null;
  var pointerFine = window.matchMedia
    ? window.matchMedia("(pointer: fine)").matches
    : true;
  var IDLE_EVENTS = ["mousemove", "keydown", "touchstart", "touchmove", "scroll"];

  function debugLog() {
    if (!debugEnabled && window.__HD_MICRO_DEBUG__ !== true) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[micro-conversion]");
    console.debug.apply(console, args);
  }

  window.hdMicroDebug = {
    enable: function () {
      debugEnabled = true;
      try {
        sessionStorage.setItem(DEBUG_KEY, "true");
      } catch (e) {}
      console.debug("[micro-conversion] debug enabled");
    },
    disable: function () {
      debugEnabled = false;
      try {
        sessionStorage.removeItem(DEBUG_KEY);
      } catch (e) {}
      console.debug("[micro-conversion] debug disabled");
    },
  };

  function sendLeadToBackend(email, reason, manual) {
    if (!isValidEmail(email)) {
      debugLog("Skipping lead submission, invalid email", {
        email: email,
        reason: reason,
        manual: manual,
      });
      return Promise.resolve(false);
    }

    var payload = {
      email: email,
      items_in_cart: latestCartSkus.join(", "),
      page_views: String(page_views),
      manual: manual ? "true" : "false",
    };

    debugLog("Sending lead to backend", {
      reason: reason,
      manual: manual,
      payload: payload,
    });

    if (typeof window.trpcFetch === "function") {
      return window.trpcFetch({
        url: "https://moken-backend.vercel.app/api/trpc/hubspot.createExitLead",
        body: payload,
      });
    }

    return fetch(
      "https://moken-backend.vercel.app/api/trpc/hubspot.createExitLead",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ json: payload }),
      },
    );
  }

  // Welcome flow: also subscribe popup signups into Klaviyo "Email List" (Vya36U),
  // alongside the existing HubSpot lead. Single opt-in list -> fires the welcome flow.
  function subscribeToEmailList(email, source) {
    try {
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=S3kgnY", {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: { data: { type: "profile", attributes: { email: email } } },
              custom_source: source || "Price-drop popup",
            },
            relationships: { list: { data: { type: "list", id: "Vya36U" } } },
          },
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  function trackLeadSubmission(email, manual, reason) {
    if (typeof window.hdTrack !== "function") return;
    try {
      window.hdTrack("Exit Intent Lead Submitted", {
        email: email,
        manual: manual ? "true" : "false",
        reason: reason,
        items_in_cart: latestCartSkus.join(", "),
        pageViews: page_views,
      });
    } catch (e) {}
  }

  var overlayEl = modal.querySelector("[data-overlay]");
  var closeBtn = modal.querySelector("[data-close]");
  var mediaEl = modal.querySelector("[data-media]");
  var imageEl = modal.querySelector("[data-image]");
  var titleEl = modal.querySelector("#hd-micro-title");
  var subtitleEl = modal.querySelector("#hd-micro-subtitle");
  var formEl = modal.querySelector("[data-form]");
  var inputEl = modal.querySelector("[data-input]");
  var submitEl = modal.querySelector("[data-submit]");
  var successEl = modal.querySelector("[data-success]");
  var errorEl = modal.querySelector("[data-error]");

  if (!overlayEl || !closeBtn || !formEl || !inputEl || !submitEl) return;

  ensureStateDefaults();
  hookEvents();
  subscribeToCartUpdates();
  refreshCart().finally(evaluateTriggers);
  monitorEmailChanges();

  function monitorEmailChanges() {
    var lastKnown = getKnownEmail();
    setInterval(function () {
      var current = getKnownEmail();
      if (current !== lastKnown) {
        debugLog("heap_email changed", { current: current });
        lastKnown = current;
        evaluateTriggers();
      }
    }, 4000);
  }

  function readState() {
    try {
      var raw = sessionStorage.getItem(SESSION_STATE_KEY);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function ensureStateDefaults() {
    if (typeof state.cartTracked !== "boolean") state.cartTracked = false;
    if (typeof state.pageTracked !== "boolean") state.pageTracked = false;
    if (typeof state.dismissed !== "boolean") state.dismissed = false;
    if (typeof state.submitted !== "boolean") state.submitted = false;
    saveState();
  }

  function saveState() {
    try {
      sessionStorage.setItem(SESSION_STATE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function incrementPageViews() {
    var count = 0;
    try {
      count = parseInt(sessionStorage.getItem(PAGE_VIEW_KEY), 10) || 0;
      count += 1;
      sessionStorage.setItem(PAGE_VIEW_KEY, String(count));
    } catch (e) {
      count = 1;
    }
    return count;
  }

  function getKnownEmail() {
    try {
      var value = localStorage.getItem(HEAP_EMAIL_KEY);
      return value && value.trim() ? value.trim() : null;
    } catch (e) {
      return null;
    }
  }

  function subscribeToCartUpdates() {
    if (typeof subscribe === "function" && window.PUB_SUB_EVENTS) {
      debugLog("Subscribing to cart updates via pubsub");
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        if (payload && payload.cartData) {
          setCart(payload.cartData);
        } else {
          refreshCart();
        }
      });
    }
  }

  function refreshCart() {
    debugLog("Fetching /cart.js");
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart fetch failed");
        return res.json();
      })
      .then(setCart)
      .catch(function () {});
  }

  function setCart(cart) {
    latestCart = cart || null;
    latestCartSkus = extractSkus(latestCart);
    debugLog("Cart updated", {
      itemCount:
        latestCart && typeof latestCart.item_count === "number"
          ? latestCart.item_count
          : null,
      skus: latestCartSkus,
    });
    evaluateTriggers();
  }

  function extractSkus(cart) {
    if (!cart || !cart.items) return [];
    var list = [];
    cart.items.forEach(function (item) {
      var sku = String(item.sku || "").trim();
      if (sku) {
        list.push(sku);
        return;
      }
      if (item.variant_id) {
        list.push("variant_" + item.variant_id);
        return;
      }
      if (item.id) list.push("id_" + item.id);
    });
    return list;
  }

  function hookEvents() {
    overlayEl.addEventListener("click", closeModal);
    closeBtn.addEventListener("click", closeModal);
    inputEl.addEventListener("input", handleInput);
    formEl.addEventListener("submit", handleSubmit);
  }

  function handleInput() {
    hideFeedback();
    submitEl.disabled = !isValidEmail(inputEl.value);
    debugLog("Email input updated", {
      value: inputEl.value,
      valid: isValidEmail(inputEl.value),
    });
  }

  function hideFeedback() {
    [successEl, errorEl].forEach(function (el) {
      if (!el) return;
      el.classList.add("tw-hidden");
      el.textContent = "";
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    hideFeedback();

    var email = (inputEl.value || "").trim();
    var reasonKey = currentVariant === "cart" ? "cart" : "browsing";

    if (!isValidEmail(email)) {
      debugLog("Submit blocked (invalid email)", { email: email });
      showError("Please enter a valid email address.");
      submitEl.disabled = true;
      inputEl.focus();
      return;
    }

    submitEl.disabled = true;
    submitEl.classList.add("tw-opacity-75");
    debugLog("Submitting lead", {
      email: email,
      variant: currentVariant,
      reason: reasonKey,
      items_in_cart: latestCartSkus,
      page_views: page_views,
    });

    try {
      if (typeof window.hdIdentify === "function") {
        try {
          window.hdIdentify(email, {
            source: "micro_conversion_modal",
            trigger_reason: reasonKey,
          });
        } catch (e) {}
      }
    } catch (e) {}

    subscribeToEmailList(email, "Price-drop popup (" + reasonKey + ")");

    sendLeadToBackend(email, reasonKey, true)
      .then(function () {
        debugLog("Lead submission success", { email: email, reason: reasonKey });
        successEl.textContent =
          reasonKey === "cart"
            ? "Thanks! We'll keep you updated."
            : "You're in! Watch your inbox for updates.";
        successEl.classList.remove("tw-hidden");
        state.submitted = true;
        state.dismissed = true;
        saveState();
        trackLeadSubmission(email, true, reasonKey);
        setTimeout(closeModal, 1800);
      })
      .catch(function (error) {
        debugLog("Lead submission failed", { error: error });
        showError("Something went wrong. Please try again.");
        submitEl.disabled = false;
      })
      .finally(function () {
        submitEl.classList.remove("tw-opacity-75");
      });
  }

  function showError(message) {
    errorEl.textContent = message;
    errorEl.classList.remove("tw-hidden");
  }

  function evaluateTriggers() {
    var emailKnown = Boolean(getKnownEmail());
    var hasCartItems = latestCartSkus.length > 0;
    var reason = null;

    debugLog("Evaluating triggers", {
      emailKnown: emailKnown,
      hasCartItems: hasCartItems,
      page_views: page_views,
      state: state,
      armedReason: armedReason,
    });

    if (state.submitted || state.dismissed) {
      debugLog("Modal already used this session", {
        submitted: state.submitted,
        dismissed: state.dismissed,
      });
      disarm();
      return;
    }

    if (hasCartItems && !state.cartTracked) {
      reason = "cart";
    } else if (!hasCartItems && page_views >= 3 && !state.pageTracked) {
      reason = "browsing";
    } else {
      debugLog("Trigger conditions not met yet", {
        hasCartItems: hasCartItems,
        page_views: page_views,
        state: state,
      });
      disarm();
      return;
    }

    if (armedReason !== reason) {
      debugLog("Switching armed reason", { from: armedReason, to: reason });
      disarm();
    }

    if (!armedReason) {
      armedReason = reason;
      debugLog("Arming trigger", {
        reason: reason,
        pointerFine: pointerFine,
        emailKnown: emailKnown,
      });
      if (pointerFine) attachExitIntent();
      startIdleWatcher();
    } else if (emailKnown) {
      debugLog("Trigger armed with known email", { reason: armedReason });
    }
  }

  function attachExitIntent() {
    if (exitListenerAttached) return;
    exitListenerAttached = true;
    debugLog("Attached exit intent listener");
    document.addEventListener("mouseout", handleMouseOut);
  }

  function handleMouseOut(event) {
    debugLog("Mouseout event", {
      clientX: event.clientX,
      clientY: event.clientY,
      relatedTarget: event.relatedTarget,
    });
    if (!armedReason) return;
    if (event.relatedTarget) return;

    // Only trigger if the mouse leaves the top ~80px *and* near the right edge (~15% width)
    const viewportWidth = window.innerWidth;
    const isNearTop = event.clientY <= 80;
    const isNearRight = event.clientX >= viewportWidth * 0.85;

    if (!(isNearTop && isNearRight)) return;

    debugLog("Exit intent detected (upper-right corner)", {
      reason: armedReason,
      clientX: event.clientX,
      clientY: event.clientY,
    });
    openModal(armedReason);
  }

  function startIdleWatcher() {
    resetIdleTimer();
    if (idleEventsBound) return;
    debugLog("Starting idle watcher", { delay: IDLE_DELAY_MS });
    IDLE_EVENTS.forEach(function (evt) {
      document.addEventListener(evt, resetIdleTimer, { passive: true });
    });
    idleEventsBound = true;
  }

  function resetIdleTimer() {
    if (!armedReason) return;
    if (idleTimer) clearTimeout(idleTimer);
    debugLog("Idle timer reset", { reason: armedReason });
    idleTimer = setTimeout(function () {
      debugLog("Idle timer fired", { reason: armedReason });
      openModal(armedReason);
    }, IDLE_DELAY_MS);
  }

  function disarm() {
    armedReason = null;
    if (exitListenerAttached) {
      document.removeEventListener("mouseout", handleMouseOut);
      exitListenerAttached = false;
    }
    if (idleEventsBound) {
      IDLE_EVENTS.forEach(function (evt) {
        document.removeEventListener(evt, resetIdleTimer);
      });
      idleEventsBound = false;
    }
    if (idleTimer) {
      clearTimeout(idleTimer);
      idleTimer = null;
    }
    debugLog("Disarmed trigger");
  }

  function openModal(reason) {
    if (!reason) return;
    var reasonKey = reason === "cart" ? "cart" : "browsing";
    var knownEmail = getKnownEmail();

    if (knownEmail) {
      var shouldSend = false;

      if (reasonKey === "cart" && !state.cartTracked) {
        state.cartTracked = true;
        shouldSend = true;
      } else if (reasonKey === "browsing" && !state.pageTracked) {
        state.pageTracked = true;
        shouldSend = true;
      } else {
        debugLog("Auto lead already handled", {
          reason: reasonKey,
          cartTracked: state.cartTracked,
          pageTracked: state.pageTracked,
        });
      }

      if (shouldSend) {
        saveState();
        trackPrompt(false, reasonKey);
        if (isValidEmail(knownEmail)) {
          sendLeadToBackend(knownEmail, reasonKey, false)
            .then(function () {
              debugLog("Auto lead submission success", {
                email: knownEmail,
                reason: reasonKey,
              });
              trackLeadSubmission(knownEmail, false, reasonKey);
            })
            .catch(function (error) {
              debugLog("Auto lead submission failed", {
                error: error,
                email: knownEmail,
                reason: reasonKey,
              });
            });
        } else {
          debugLog("Known email invalid, skipping auto submission", {
            email: knownEmail,
          });
        }
      }

      disarm();
      return;
    }

    disarm();
    debugLog("Opening modal", { reason: reasonKey });
    currentVariant = reasonKey === "cart" ? "cart" : "community";
    applyVariant(currentVariant);
    hideFeedback();
    inputEl.value = "";
    submitEl.disabled = true;

    modal.classList.remove("tw-hidden");
    document.body.classList.add("hd-micro-modal-open");
    lastActiveElement = document.activeElement;

    if (typeof trapFocus === "function") {
      trapFocus(modal, inputEl);
    } else {
      inputEl.focus();
    }

    document.addEventListener("keydown", onKeyDown);

    if (currentVariant === "cart") {
      state.cartTracked = true;
    } else {
      state.pageTracked = true;
    }
    saveState();
    trackPrompt(true, reasonKey);
  }

  function applyVariant(variant) {
    var ds = modal.dataset;
    var config =
      variant === "cart"
        ? {
            title: ds.cartTitle,
            subtitle: ds.cartSubtitle,
            cta: ds.cartCta,
            image: ds.cartImage,
          }
        : {
            title: ds.communityTitle,
            subtitle: ds.communitySubtitle,
            cta: ds.communityCta,
            image: ds.communityImage,
          };

    titleEl.textContent = config.title || "";
    subtitleEl.textContent = config.subtitle || "";
    submitEl.textContent = config.cta || "";

    if (config.image) {
      imageEl.src = config.image;
      imageEl.alt = "";
      mediaEl.classList.remove("tw-hidden");
    } else {
      mediaEl.classList.add("tw-hidden");
      imageEl.removeAttribute("src");
    }
  }

  function trackPrompt(manual, reason) {
    if (typeof window.hdTrack !== "function") return;
    try {
      debugLog("Tracking prompt", { manual: manual, reason: reason });
      window.hdTrack("Exit Intent Prompt", {
        manual: manual ? "true" : "false",
        reason: reason,
        items_in_cart: latestCartSkus.join(", "),
        pageViews: page_views,
      });
    } catch (e) {}
  }

  function closeModal() {
    if (modal.classList.contains("tw-hidden")) return;
    debugLog("Closing modal");
    modal.classList.add("tw-hidden");
    document.body.classList.remove("hd-micro-modal-open");
    document.removeEventListener("keydown", onKeyDown);
    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(lastActiveElement || null);
    } else if (lastActiveElement && lastActiveElement.focus) {
      lastActiveElement.focus();
    }
    state.dismissed = true;
    saveState();
  }

  function onKeyDown(event) {
    if (event.key === "Escape") {
      closeModal();
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }
})();
